import type { RouteRecordRaw } from "vue-router";

const isPathInModule = (
  path: string,
  ignoreModules: string[] = [],
): boolean => {
  const mainModule = path.match(/modules\/(\w+)\//)?.[1];
  const subModule = path.match(/modules\/\w+\/(\w+)\//)?.[1];

  return !!(
    mainModule &&
    [import.meta.env.VITE_APP_IDENTIFIER, "shared"].includes(mainModule) &&
    subModule &&
    !ignoreModules.includes(subModule)
  );
};

export const moduleRoutesBuilder = (
  ignoreModules?: string[],
): RouteRecordRaw[] => {
  const moduleRoutes = import.meta.glob<{ default: RouteRecordRaw[] }>(
    `@/modules/**/routes.ts`,
    { eager: true },
  );

  const routes = Object.entries(moduleRoutes)
    .filter(([path]) => isPathInModule(path, ignoreModules))
    .flatMap(([, routes]) => routes.default);

  return routes;
};
